import { render, staticRenderFns } from "./DetalhesFornecedor.vue?vue&type=template&id=9bd219fc&lang=pug"
import script from "./DetalhesFornecedor.vue?vue&type=script&lang=js"
export * from "./DetalhesFornecedor.vue?vue&type=script&lang=js"
import style0 from "./DetalhesFornecedor.vue?vue&type=style&index=0&id=9bd219fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports